import { fetchOfferBasedRecommendations } from 'actions/RecommendationActions'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import React, { useEffect, useRef } from 'react'
import { getExpiredOfferRecommendationsState } from 'selectors/recommendations'

import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { useAppDispatch } from 'hooks/reduxHooks'

type Props = React.PropsWithChildren<{
  checkIn: string | undefined;
  checkOut: string | undefined;
  offerId: string;
  offerExpired: boolean;
  offerLoadingDone: boolean
}>;

function ExpiredLereRenderGuard(props: Props) {
  const { checkIn, checkOut, offerId, offerExpired } = props
  const dispatch = useAppDispatch()
  const shouldFetchRecommendations = offerExpired

  const fetchTriggered = useRef(false)

  useEffect(() => {
    if (fetchTriggered.current) {
      return
    }
    if (shouldFetchRecommendations) {
      fetchTriggered.current = true
      dispatch(fetchOfferBasedRecommendations(offerId, false, checkIn, checkOut))
    }
  }, [dispatch, offerId, shouldFetchRecommendations, checkIn, checkOut])

  if (!offerExpired) {
    return null
  }

  return (<>{props.children}</>)
}

export default withOfferPageAndReduxState((state, appState: App.State) => {
  const offerId = state?.offer?.id
  const offersState = getExpiredOfferRecommendationsState(appState, offerId)
  const checkIn = state?.checkInDate?.format(ISO_DATE_FORMAT)
  const checkOut = state?.checkOutDate?.format(ISO_DATE_FORMAT)
  return {
    checkIn,
    checkOut,
    offerId,
    offerExpired: offersState.offerExpired,
    offerLoadingDone: ['done', 'error'].includes(offersState.loadingState),
  }
})(ExpiredLereRenderGuard)
